import { createChangeRequest } from '../services/analyticsChangeRequests';

/**
 * Подача заявки в точной форме production-контракта C3:
 * `{ request_type, zone_id, payload }`.
 *
 * `zone_id` — идентичность заявки на изменение или удаление зоны, поэтому он
 * поднимается верхним полем, а не прячется в payload. Конкурентность backend
 * контролирует полем expected_version внутри payload; поля base_version в
 * production-контракте нет, и придумывать его фронт не должен.
 */
export const submitChangeRequest = (cameraId, requestType, sourcePayload = {}) => {
  const payload = { ...sourcePayload };
  const zoneId = payload.zone_id ?? null;
  delete payload.zone_id;

  return createChangeRequest(cameraId, {
    request_type: requestType,
    zone_id: zoneId,
    payload,
  });
};
